import { useState, useCallback, useMemo } from 'react';

/**
 * Takes in props and creates event handlers that can be passed to a component along with
 * a boolean representing the hover state
 *
 * @param {object} props - The props of the component that will be hovered on to avoid prop override
 * @returns {[boolean, {onMouseEnter: Function, onMouseLeave: Function}]} - A two-element,
 * mixed-type array where the first element is a boolean indicating the element is
 * focused or hovered and the second element is an object containing
 * the event handlers to attach to the element
 */
const useHover = props => {
  const {
    onMouseEnter: onMouseEnterFromProps,
    onMouseLeave: onMouseLeaveFromProps
  } = props;
  const [isHovering, setIsHovering] = useState(false);
  const onMouseEnter = useCallback(event => {
    if (!isHovering) {
      setIsHovering(true);
    }
    event.stopPropagation();
    if (onMouseEnterFromProps) {
      onMouseEnterFromProps(event);
    }
  }, [onMouseEnterFromProps, isHovering]);
  const onMouseLeave = useCallback(event => {
    if (isHovering) {
      setIsHovering(false);
    }
    if (onMouseLeaveFromProps) {
      onMouseLeaveFromProps(event);
    }
  }, [onMouseLeaveFromProps, isHovering]);
  const eventHandlerProps = useMemo(() => ({
    onMouseEnter,
    onMouseLeave
  }), [onMouseEnter, onMouseLeave]);
  return [isHovering, eventHandlerProps];
};
var useHover$1 = useHover;

export { useHover$1 as default };
